/**
 * Selects the storage used by the offline database.
 *
 * RxDB dev mode requires a schema-validating wrapper. Keeping this decision in
 * a tiny pure helper makes the requirement testable without opening IndexedDB.
 */
export function selectOfflineStorage<T, V>(
  storage: T,
  isDevelopment: boolean,
  validate: (args: { storage: T }) => V,
): T | V {
  return isDevelopment ? validate({ storage }) : storage
}
